import styled, { css } from 'styled-components';

const ButtonRow = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	margin-bottom: 1em;
	& > * {
		margin-right: 0.25em;
	}
	@media screen and (max-width: 45em) {
		display: flex;
		${(props) => {
			if (props.numElements > 2) {
				return css`
					flex-direction: column;
					margin-right: 0;
				`;
			}
		}}
		& > button, & > span {
			width: 100%;
		}
	}
`;

export default ButtonRow;
